import { PLACE_ORDER, CHECKOUT_EMPTY } from "./actionTypes";

const initialState = {
    checkout: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case PLACE_ORDER:
            return { ...state, checkout: action.payload };
        case CHECKOUT_EMPTY:
            return { ...state, checkout: action.payload };
        default:
            return state;
    }
}
